import { fontWeights } from '../constants/font-weights.js';

var ariaLabels = {
  /**
   * Prefixes each day with the given string, fore example: "Choose Thursday 24th of March"
   */
  chooseDayAriaLabelPrefix: {
    fi: 'Valitse',
    en: 'Choose',
    sv: 'Välj'
  },
  /**
   * Prefixes each disabled day with the given string, fore example: "Not available Thursday 24th of March"
   */
  disabledDayAriaLabelPrefix: {
    fi: 'Ei käytettävissä',
    en: 'Not available',
    sv: 'Inte tillgänglig'
  },
  /**
   * Prefix that translates to week
   */
  weekAriaLabelPrefix: {
    fi: 'Viikko',
    en: 'Week',
    sv: 'Vecka'
  },
  /**
   * Aria label for next month button
   */
  nextMonthAriaLabel: {
    fi: 'Seuraava kuukausi',
    en: 'Next month',
    sv: 'Nästa månad'
  },
  /**
   * Aria label for previous month button
   */
  previousMonthAriaLabel: {
    fi: 'Edellinen kuukausi',
    en: 'Previous month',
    sv: 'Förra månaden'
  },
  /**
   * Aria label for next year button
   */
  nextYearAriaLabel: {
    fi: 'Seuraava vuosi',
    en: 'Next year',
    sv: 'Nästa år'
  },
  /**
   * Aria label for previous year button
   */
  previousYearAriaLabel: {
    fi: 'Edellinen vuosi',
    en: 'Previous year',
    sv: 'Förra året'
  }
};
var datepickerThemeWeb = {
  color: 'primary',
  innerBorder: 'border.light',
  items: {
    font: {
      weight: fontWeights.light
    },
    today: {
      font: {
        weight: fontWeights.medium
      }
    },
    disabled: 'text.disabled',
    hover: 'background.secondary'
  },
  ariaLabels: ariaLabels
};
var datepickerThemeNative = {
  color: 'primary',
  dayPicker: {
    arrowColor: 'primary',
    arrowDisabledColor: 'text.disabled'
  },
  datePickerButton: {
    size: 40,
    borderRadius: 20
  },
  ariaLabels: ariaLabels
};

export { datepickerThemeNative, datepickerThemeWeb };
